import { IInstitutionConfiguration } from '@shared/types/base'

export const CConfiguration: IInstitutionConfiguration = {
	certificates: {
		decimals: 0,
		cycleMask: '',
		hasAccents: false,
		mayus: false
	},
	degree: {
		conectorCarreraNivel: '',
		hasAccents: false,
		services: {
			id: '',
			url: '',
			user: ''
		}
	}
}
